export const getProcessEnv = () => {
  const procesed = Object.getOwnPropertyNames(process.env).reduce((acc, key) => {
    return {
      ...acc,
      [key]: process.env[key],
    }
  }, {})
  return procesed
}
